export default "__VITE_ASSET__ChW1kAAz__"